<template>

  <div class="row w-100">

    <div class="col-12 text-md-right mb-3">
      <!-- SEARCH -->
      <input class="form-control-sm w-100 border"
             v-on:keyup="search_members" type="text" placeholder="Rechercher ..."
             v-model="query">
      <!-- END SEARCH -->
    </div>


    <div class="col-sm-6 col-lg-4 col-xl-3 mb-2 mb-sm-3"
         v-for="member in members"
         :key="member.id">
      <div class="card h-100">
        <div class="card-body">

          <img class="avatar avatar-circle" :src="member.photo_url"/>

          <h5 :id="'receiver' + member.id" :name="member.name" class="h6 mb-2 receiver-name">{{ member.fullname }}</h5>
          <div class="media align-items-center">
            <div class="media-body">
              <input class="d-none" type="checkbox" :id="'checkbox-' + member.id" :name="member.id" :value="member.id">
              <span class="btn btn-danger btn-xs btn-icon rounded-circle receiver-action add-receiver"
                    :data-id="member.id" onclick="setReceiver(this)"><i class="fa fa-plus"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['group_id'],
  data: function () {
    return {
      members: [],
      member_id: 0,
      member_name: "",
      query: '',
      order_by: 'name',
      order_direction: 'asc',
    }
  },

  mounted() {
    console.log('Component mounted.');
    if (this.group_id === undefined) {
      this.group_id = 0
    }
    this.get_members();
  },
  methods: {
    get_members: function () {
      const _this = this

      const url = '/modules/daentreprise/actions/members.php'

      axios.get(url +
          '?group_id=' + _this.group_id +
          '&query=' + _this.query +
          '&order_by=' + _this.order_by +
          '&order_direction=' + _this.order_direction)
          .then(function (response) {
            _this.members = response.data.members
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    search_members() {
      this.get_members();
    },

    send_message(member_id, member_name) {
      this.member_id = member_id;
      this.member_name = member_name;

      $('#new_message_modal').modal('show');
    }
  },
}
</script>

